module.exports = __webpack_public_path__ + "img/banner.0ceff20a.jpg";